import { render, staticRenderFns } from "./ComprehensiveTestingStudentCard.vue?vue&type=template&id=13be608c&scoped=true&"
import script from "./ComprehensiveTestingStudentCard.vue?vue&type=script&lang=js&"
export * from "./ComprehensiveTestingStudentCard.vue?vue&type=script&lang=js&"
import style0 from "./ComprehensiveTestingStudentCard.vue?vue&type=style&index=0&id=13be608c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13be608c",
  null
  
)

export default component.exports